<section>
  <div class="row mx-0" [hidden]="!isFormView">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-register-provider-invoice-detail [providerInvoiceModel]="providerInvoiceModel"
        [providerInvoiceDetailModel]="providerInvoiceDetailModel" [permissionUpdatable]="permissionUpdatable"
        (updateListDetail)="getUpdateListDetail()" (providerInvoiceContract)="getProviderInvoice($event)"
        (isFormView)="getFormView($event)"></app-register-provider-invoice-detail>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
      [showCheckbox]="!disableDetail" [checkBoxAction]="checkboxActions" [clearSelectionTrigger]="clearSelectionTrigger"
      (onPageChange)="onPageChange($event)" (onRecoverData)="getDetailsProviderInvoiceWithPagination()"
      (onAction)="onAction($event)">
    </app-custom-table>
  </div>
</section>